import { render, staticRenderFns } from "./Fruehstueckextras.vue?vue&type=template&id=54a97884&scoped=true"
import script from "./Fruehstueckextras.vue?vue&type=script&lang=js"
export * from "./Fruehstueckextras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a97884",
  null
  
)

export default component.exports